import { faWifiExclamation, faWifiSlash } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type PusherState =
  | 'initialized'
  | 'connecting'
  | 'connected'
  | 'unavailable'
  | 'failed'
  | 'disconnected';

interface ConnectionStatusProps {
  lastUpdated: string;
  states: { previous: PusherState; current: PusherState };
}

const ConnectionStatus = (props: ConnectionStatusProps) => {
  return <div className={`bg-black/50 p-2 text-sm`}>{renderConnectionStatus(props)}</div>;
};

const renderConnectionStatus = ({ states, lastUpdated }: ConnectionStatusProps) => {
  const { previous, current } = states;

  if (
    (previous === 'connected' && current === 'connecting') ||
    (previous === 'unavailable' && current === 'connecting')
  ) {
    return (
      <>
        <FontAwesomeIcon icon={faWifiExclamation} className={`text-yellow-300`} />
        &nbsp;Retrying Connection
      </>
    );
  }

  if (previous === 'connecting' && current === 'unavailable') {
    return (
      <>
        <FontAwesomeIcon icon={faWifiSlash} className={`text-red-500`} />
        &nbsp;Last Updated {lastUpdated}
      </>
    );
  }

  return <>{current.toUpperCase()}</>;
};

export type { ConnectionStatusProps };
export { ConnectionStatus };
